import { TextField } from "@mui/material";
import { useEffect } from "react";

import { useInputText } from "@/hooks";
import { useFormLesson } from "@/stores/form-exam";

export function InputDescription() {
  const store = useFormLesson();
  const input = useInputText({ description: "" });

  const onInputTextChange = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (store.selectedQuestion) {
      const { value } = event.currentTarget;
      store.setQuestion(store.selectedQuestion.id, { description: value });
      input.onChange(event);
    }
  };

  useEffect(() => {
    if (store.selectedQuestion && store.selectedQuestion.description)
      input.updateInitial("description", store.selectedQuestion.description);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.selectedQuestion]);

  if (!store.selectedQuestion) return null;

  return (
    <TextField
      required
      multiline
      minRows={4}
      maxRows={8}
      label="Question"
      name="description"
      value={input.description}
      onChange={onInputTextChange}
      // onChange={input.onChange}
      onBlur={input.onBlur}
      error={!!input.errors.description}
      helperText={input.errors.description}
      disabled
    />
  );
}
